<template>
  <div class="block page13 f-c">
    <PageHeader
      :title="moduleData['3_13_1_0']"
      :sub-title="moduleData['3_13_1_0_en']"
      :page-logo="reportCustomization.pageLogo"
    />
    <PageTips :page-num="pageNum"/>
    <div class="page13-body f-c">
      <TableNav width="1774px" style="height: 70px; margin-bottom: 25px">
        <template v-slot:title>
          <div class="page13-table-header f-r j-b">
            <div class="page13-table-title">
              {{ moduleData["3_13_2_1"] }}
            </div>
            <div class="page13-table-sub-title">
              {{ PAGE_TEXT[commonLang].totalOfficeBuildings }}{{ catData.count }}{{ PAGE_TEXT[commonLang].unitPiece }}
            </div>
          </div>
        </template>
      </TableNav>
      <div style="width: 1774px" class="f-r j-b" v-if="rowData.length">
        <PTable
          :is-small="commonLang !== 'zh'"
          :col-data="colData"
          :row-data="rowData.slice(0,10)"
        />
        <PTable v-if="rowData.length > 10" :col-data="colData" :row-data="rowData.slice(10,20)">
        </PTable>
      </div>
      <div style="flex-grow: 1; " class="page13-map-tips f-c j-e">
        <Empty :text="PAGE_TEXT[commonLang].noOfficeCoverage" v-if="!rowData.length"/>
        <div
          v-if="reportCustomization.showWater"
          class="page-tips2" style="padding-bottom: 27px;"
        >{{ PAGE_TEXT[commonLang].moreInfo }}</div>
        <div v-if="reportCustomization.showDataSource">
          {{ PAGE_TEXT[commonLang].dataSource }}
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref } from "vue";
import PageHeader from "./components/PageHeader";
import PageTips from "./components/PageTips";
import TableNav from "./components/TableNav";
import PTable from "./components/PTable";
import Empty from "./components/Empty";

const props = defineProps({
    pageNum: String,
    catData: {
      type: Object,
      default: () => {
        return {
          count: 0,
          poi: []
        };
      },
    },
    moduleData: {
      type: Object,
      default: () => {}
    },
    reportCustomization: {
      type: Object,
      default: () => {},
    },
    commonLang: {
      type: String,
      default: 'zh'
    }
  });

const PAGE_TEXT = {
  'zh': {
    totalOfficeBuildings: '总办公楼项目数：',
    unitPiece: '个',
    noOfficeCoverage: '当前区域暂无办公楼覆盖',
    moreInfo: '>更多写字楼分布于APP「数据地图/市调详情_周边配套」中查看',
    dataSource: '数据来源：边界房产大数据，房产平台数据整合',
    serialNumber: '序号',
    type: '类型',
    officeBuildingName: '写字楼名称',
    distance: '距离'
  },
  'en': {
    totalOfficeBuildings: 'Total Office Buildings: ',
    unitPiece: 'pieces',
    noOfficeCoverage: 'No office building coverage in current area',
    moreInfo: '',
    dataSource: 'Data Source: Boundary real estate big data, real estate platform data integration',
    serialNumber: 'No.',
    type: 'Type',
    officeBuildingName: 'Office Building Name',
    distance: 'Distance'
  }
};

    const colData = computed(() => [
      { prop: "index", width: "67px", label: PAGE_TEXT[props.commonLang].serialNumber },
      { prop: "subCate", width: "133px", label: PAGE_TEXT[props.commonLang].type },
      { prop: "name", width: "486px", label: PAGE_TEXT[props.commonLang].officeBuildingName },
      { prop: "distanceKilo", width: "157px", label: PAGE_TEXT[props.commonLang].distance , subLabel: "km"},
    ]);
    const rowData = computed(() => {
        return props.catData.poi.slice(0,20).map((el,index) => {
            let _index = index + 1
            return {
                index: _index < 10 ? ('0' + _index) : _index,
                ...el
            }
        })
    });
</script>

<style lang="less">
.page13 {
  position: relative;
  background: #ffffff;
  padding: 26px 60px 32px 0;
  .page13-body {
    flex-grow: 1;
    padding: 17px 20px 0 39px;
    .page13-table-header {
      display: flex;
      .page13-table-title {
        font-size: 36px;
      }
      .page13-table-sub-title {
        font-size: 21px;
      }
    }

    .page13-map-tips {
      position: relative;
      width: 100%;
      flex-shrink: 0;
      text-align: right;
      height: 28px;
      font-size: 20px;
      font-weight: 400;
      color: #9a9a9a;
      line-height: 28px;
    }
  }
}
</style>
